import _ from 'lodash';
import $ from 'jquery';
import viewport from 'gears/support/viewport/component';
import ShowableWidget from 'gears/ui/showable-widget/component';
import Button from 'gears/ui/button/component';
import Progress from 'gears/ui/progress/component';

// The global instance
let singleton = undefined;

$.extend($.expr[':'], {
  inview(a) {
    let st = (document.documentElement.scrollTop || document.body.scrollTop);
    let ot = $(a).offset().top;
    let wh = (window.innerHeight && (window.innerHeight < $(window).height())) ? window.innerHeight : $(window).height();
    return (ot > st) && (($(a).height() + ot) < (st + wh));
  }
}
);

class Modal extends ShowableWidget {

  // TODO: implement some of these ideas
  // http://www.nczonline.net/blog/2013/02/12/making-an-accessible-dialog-box/

  constructor(options) {
    super(...arguments);

    // The constructor should return the singleton instance if it exists
    if (singleton instanceof Modal && singleton.state() !== "destroyed") {
      return singleton.set(options);
    }

    singleton = this;
  }

  show() {
    let scrollbarWidth = window.innerWidth ?
      window.innerWidth - document.documentElement.clientWidth
    :
      0;

    if (scrollbarWidth) { $(document.body).css("margin-right", scrollbarWidth); }

    $(document.body).addClass(`is-${this.constructor.className}-showing`);
    return super.show(...arguments);
  }

  destroy() {
    $(document).off(`.${this._getNamespace()}`);
    return super.destroy(...arguments);
  }

  _onShown() {
    this._setFocus();
    this._configureKeyEvents();
    this._preventTabbingOutside();
    return super._onShown(...arguments);
  }

  _onHidden() {
    $(document.body)
      .css("margin-right", 0)
      .removeClass(`is-${this.constructor.className}-showing`);
    $(document).off(`.${this._getNamespace()}`);
    return super._onHidden(...arguments);
  }

  _update() {
    this._render();
    // We also need to re-register the tab listener in case tabbable
    // elements have been added/removed from the modal.
    return this._preventTabbingOutside();
  }

  _render() {
    let contents;
    if (!this.$el) { this.$el = $(`\
<div class="${Modal.className}" tabindex="-1">
<div class="${Modal.className}__dialog-container" />
</div>\
`); }
    this.$el.data(this._getNamespace(), this);

    // setting the HTML overrides setting header, body, and footer
    if (this.options.html) {
      contents = [this.options.html];
    } else {
      contents = [this._renderHeader(), this._renderBody(), this._renderFooter()];
    }

    let $dialog = this.$el.find(".modal__dialog");
    if ($dialog.length) {
      $dialog.empty().append(contents);
    } else {
      $dialog = $(`<div class=\"${Modal.className}__dialog\" tabindex=\"-1\">`).appendTo(this.$el.children());
      $dialog.append.apply($dialog, contents);
    }

    this._setDimensions();
    this._configureHideButtons();
    if (this.state() === "shown") { return this._setFocus(); }
  }

  _renderHeader() {
    let $header = $(`\
<div class="${Modal.className}__header">
<h3 class="${Modal.className}__title">${this.options.title}</h3>
</div>\
`);
    if (this.options.hideable) {
      $header.append(`\
<a href="#" class="js-${Modal.className}-hide ${Modal.className}__hide"></a>\
`);
    }
    return $header;
  }

  _renderBody() {
    return $(`<div class=\"${Modal.className}__body\" />`).append(this.options.body);
  }

  _renderFooter() {
    if (this.options.footer) {
      let footer = $(`<div class=\"${Modal.className}__footer\" />`).append(this.options.footer);
      if (this.options.stackButtons) { footer.addClass(`${Modal.className}__footer--stacked`); }
      return footer;
    } else {
      return null;
    }
  }

  _setDimensions() {
    if (this.options.width) { return this.$el.find(`.${Modal.className}__dialog`).css({"maxWidth": this.options.width}); }
  }

  _configureHideButtons() {
    let self = this;
    return self.$el
      .off(`click.${this._getNamespace()}`)
      .on(`click.${this._getNamespace()}`, `.js-${Modal.className}-hide`, function(e) {
        e.preventDefault();
        return self.options.onUserHide.call(self);
      });
  }

  _preventTabbingOutside() {
    let $tabbables = this.$el.find("input, button, select, textarea, a[href]").not(":hidden, :disabled");
    let $first = $tabbables.first();
    let $last  = $tabbables.last();

    return $(document).off(`keydown.${this._getNamespace()}`).on(`keydown.${this._getNamespace()}`, e => {
      if (e.keyCode !== 9) { return; }
      if (!e.shiftKey && ( $last.is(e.target) || this.$el.is(e.target) )) {
        $first.focus();
        return false;
      } else if (e.shiftKey && ( $first.is(e.target) || this.$el.is(e.target))) {
        $last.focus();
        return false;
      }
    }
    );
  }

  _configureKeyEvents() {
    let self = this;
    return $(document).on(`keyup.${this._getNamespace()}`, function(e) {
      if ((e.keyCode === 27) && self.options.hideable) {
        return self.options.onUserHide.call(self);
      }
    });
  }

  _setFocus() {
    if (!__guard__(window.Modernizr, x => x.touch) && (viewport() !== 'small')) {
      // autofocus on the first logical element in the modal
      return this.$el
        .find(":input:not(:hidden):not(:disabled):not([type=file]):not(.js-no-autofocus)")
        .filter(":inview")
        .first()
        .focus();
    }
  }
}


Modal.defaults = {
  animate: true,
  hideable: true,
  onUserHide: Modal.prototype.hide,
  destroyOnHidden: true,
  removeOnHidden: true,
  stackButtons: false
  // title: (optional)
  // body: (optional)
  // html: (options)
  // footer: (optional)
  // width: 400 (this default is in the CSS, but it can be overridden in JavaScript)
};

Modal.className = "modal";

Modal.namespace = "gears:modal";


// "Class" methods

Modal.wait = function(options) {
  if (options == null) { options = {}; }
  if (__guard__(window.Modernizr, x => x.cssanimations)) {
    options.body = new Progress({value:100}).$el;
  } else {
    options.body = '<div class="modal__spinner"></div>';
  }

  options = _.extend({}, Modal.defaults, Modal.wait.defaults, options);
  return new Modal(options).show();
};

Modal.wait.defaults = {
  title: "Please Wait...",
  footer: null
};

Modal.confirm = function(options) {
  if (options == null) { options = {}; }
  options = _.extend({}, Modal.defaults, Modal.confirm.defaults, options);
  return _dialog(options);
};

Modal.confirm.defaults = {
  title: "Please Confirm",
  // body: "Are you sure you want to continue?"
  continueLabel: "OK",
  cancelLabel: "Cancel"
};


Modal.alert = function(options) {
  if (options == null) { options = {}; }
  options = _.extend({}, Modal.defaults, Modal.alert.defaults, options);
  return _dialog(options);
};

Modal.alert.defaults = {
  title: "Warning",
  // body: "Are you sure you want to continue?"
  continueLabel: "OK"
};


// Private methods

var _dialog = function(options) {

  let deferred = $.Deferred();
  let $footer = $();

  // create the continue button
  let continueButtonOptions = {
    title: options.continueLabel,
    onClick: deferred.resolve
  };
  if (options.cancelLabel) { continueButtonOptions.type = "primary"; }
  let continueButton = new Button(continueButtonOptions);
  $footer = $footer.add(continueButton.$el);

  // create the cancel button (if needed)
  if (options.cancelLabel) {
    let cancelButton = new Button({
      title: options.cancelLabel,
      onClick: deferred.reject
    });
    $footer = $footer.add(cancelButton.$el);
  }

  // merge the options
  options = _.extend(
    _.omit(options, "continueLabel", "cancelLabel"),
    {
      destroyOnHidden: true,
      footer: $footer,
      // closing the modal should resolve the deferred in the
      // alert case and reject it in the confirm case
      onUserHide: options.cancelLabel ? deferred.reject : deferred.resolve
    }
  );
  let modal = new Modal(options).show();

  return deferred.promise().always( _.bind(modal.hide, modal) );
};

export default Modal;

function __guard__(value, transform) {
  return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined;
}
